import { VirtualRoomMeta } from '~/types/resources';
import { externalApi } from '~/utils/api/external';

export const getRealmMetadata = ({ origin }: Pick<Location, 'origin'>) =>
  externalApi.get<VirtualRoomMeta>(new URL('meta', origin).href);
